import dayjs from "dayjs"
import {$moment} from "../../funcs"

export function isDatePlaceholderValue(value: unknown): boolean {
    const raw = String(value ?? "").trim()
    if (!raw) {
        return true
    }
    if (raw === "ДД.ММ.ГГГГ") {
        return true
    }
    return /ДД|ММ|ГГГГ|_{2,}/.test(raw)
}

function parseEntityDate(value: unknown) {
    if (isDatePlaceholderValue(value)) {
        return null
    }
    const raw = String(value)
    const parsed = $moment(raw, ["YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD", "LL HH:mm", "LL", "DD.MM.YYYY"], true)
    if (parsed && parsed.isValid && parsed.isValid()) {
        return dayjs(parsed.toDate())
    }
    const loose = $moment(raw)
    if (loose && loose.isValid && loose.isValid()) {
        return dayjs(loose.toDate())
    }
    return null
}

export function datePickerValueFromEntity(entity: any) {
    return parseEntityDate(entity?.raw_value) || parseEntityDate(entity?.value)
}
